import { Spinner } from 'construct-ui';
import Sortable from 'sortablejs';
import { messageComponent } from '../../../../components/message/message.component';
import loginModel from '../../../../models/login.model';
import ViewBase from '../../../view-base.view';

export default function TaskTemplateTaskListView() {

  ViewBase.call(this);
  // let userLanguageCode = "EN";
  let countryID = 0;
  let isLoading = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";

  let _onChanged = (e) => { }
  let _onRemoved = (e) => { }
  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _removeItem = (item) => {
    _onRemoved(item);
  }

  return {
    oninit: function (vnode) {
      countryID = loginModel.credentials.country;
      // userLanguageCode = loginModel.credentials.language;
      if (vnode.attrs.onChanged) {
        _onChanged = vnode.attrs.onChanged;
      }

      if (vnode.attrs._onRemoved) {
        _onRemoved = vnode.attrs._onRemoved;
      }


    },
    oncreate: function (vnode) {
      if (vnode.attrs.disabled == false) {
        const radioList = document.getElementById('tastListId');
        new Sortable(radioList, {
          animation: 150,
          ghostClass: 'sortable-ghost',
          dragClass: 'sortable-drag',
          handle: '.drag-grip',
        });
      }
    },
    onupdate: function (vnode) {
      if (countryID != loginModel.credentials.country) {
        countryID = loginModel.credentials.country;
        // userLanguageCode = loginModel.credentials.language;

      }
    },
    view: (vnode) => {
      return [
        m('.row',
          m(Spinner, {
            active: isLoading,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.card',
            m('.card-body',
              vnode.attrs.taskList.length > 0 && m('.row',
                m('.col-md-8',
                  m('label.ms-3', this.getText("LT00000078", "Task Name"))),
                m('.col-md-2',
                  m('label.ms-0', this.getText("LT00000115", "Mandatory")))
              ),
              vnode.attrs.taskList.length > 0 ? m('.row.radio-list-height',
                m('.col-md-12',
                  m('ul[id="tastListId"].moveable.p-0',
                    vnode.attrs.taskList.map(dtVal => [
                      m('li.drag-grip',
                        m('.row',
                          m('.col-md-8',
                            m("input[type='text']", {
                              "class": "form-control form-control-bg",
                              disabled: vnode.attrs.disabled,
                              value: dtVal.name,
                              onkeyup: e => {
                                dtVal.name = e.target.value;
                                _onChanged(vnode.attrs.taskList);
                              }
                            }),
                            m('input[type="hidden"][value="' + dtVal.id + '"]')
                          ),
                          m('.col-md-2',
                            m('.col-md-8',
                              m('.col-md-2',
                                dtVal.mandatory == "Y" &&
                                m('label.switcher', m('input[type="checkbox"][checked]',
                                  {
                                    disabled: vnode.attrs.disabled,
                                    onchange: e => {
                                      dtVal.mandatory = e.target.checked ? 'Y' : 'N';
                                      _onChanged(vnode.attrs.taskList);
                                    }
                                  }
                                ),
                                  m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round')),
                                dtVal.mandatory == "N" &&
                                m('label.switcher', m('input[type="checkbox"]',
                                  {
                                    disabled: vnode.attrs.disabled,
                                    onchange: e => {
                                      dtVal.mandatory = e.target.checked ? 'Y' : 'N';
                                      _onChanged(vnode.attrs.taskList);
                                    }
                                  }
                                ),
                                  m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round'))
                              ),
                            )
                          ),
                          !vnode.attrs.disabled && m('.col-md-1', m('.remove_field.mt-1',
                            {
                              onclick: e => {
                                _removeItem(dtVal);
                              }
                            },
                            m('span', m('i.bi.bi-dash-circle.me-0'))))
                        )
                      )
                    ])
                  )
                )
              ) : m('span', "Please add data.")
            )
          ),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
          this.getBaseViews()
        )]
    }
  }
}
